
<!--              /////////////////////////////////////////////////////////////////////////
                 /////      PLAN LECTOR WEBMASTER && OTROS PERFILES != ESTUDIANTES    ////
                ////////////////////////////////////////////////////////////////////////// -->

<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <v-row ref="librosSection"></v-row>
    <v-row v-if="datoLogin.descripcion_perfil === 'Estudiante'">
      <v-col cols="12" class="d-flex justify-center text-center">
        <p class="text-h4 primary--text">PLAN LECTOR DE INTELIGENIO</p>
      </v-col>
    </v-row>


    <template v-if="datoLogin.descripcion_perfil &&
      datoLogin.descripcion_perfil !== 'Estudiante' &&
      datoLogin.descripcion_perfil !== 'Familia'
      ">
      <v-row>

        <v-col cols="12" md="2" class="d-flex justify-center">
          <v-row>

            <v-col cols="12">
              <v-list>
                <v-list-group v-for="item in listNivel" :key="item.id" @click="eventNivel(item)">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.desc_nivel }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item v-for="child in gradoFilter" :key="child.id_grado" @click="eventGrado(child)" link>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ child.desc_grado }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>

              </v-list>
              <v-chip color="primary" label class="ma-2">
                Nivel : {{ nivel.desc_nivel }}
              </v-chip>
              <v-chip v-if="gradochipfilter" color="success" class="ma-2" close @click:close="eventNivel(nivel)" label>
                Grado : {{ grado.desc_grado }}
              </v-chip>
            </v-col>

          </v-row>


          <!-- {{ gradoFilter }} -->
        </v-col>
        <v-col cols="12" md="10">
          <v-row>
            <v-col cols="12" class="d-flex justify-center text-center">
              <p class="text-h4 primary--text">PLAN LECTOR DE INTELIGENIO</p>
            </v-col>
            <v-col cols="12">
              <v-data-iterator :items-per-page.sync="itemsPerPage" :page.sync="page" :items="datosFilter"
                :search="search">
                <template v-slot:header>
                  <v-row>
                    <v-col cols="12" class="d-flex justify-center pb-10">
                      <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify"
                        placeholder="Buscar libro" variant="solo" density="comfortable"
                        style="max-width:300px"></v-text-field>
                    </v-col>
                  </v-row>
                </template>

                <template v-slot:no-data>
                  <v-card outlined>
                    <v-card-text style="height: 240px" class="d-flex justify-center align-center">
                      Sin libros añadidos
                    </v-card-text>
                  </v-card>
                </template>
                <template v-slot:no-results>
                  <v-card>
                    <v-card-text style="height : 240px" class="d-flex justify-center align-center">
                      Sin datos encontrados correspondientes a su busqueda
                    </v-card-text>
                  </v-card>
                </template>

                <template v-slot:default="props">
                  <v-row>
                    <v-col v-for="item in props.items" class="d-flex justify-center" :key="item.id" cols="12" sm="6"
                      md="4" lg="3">
                      <v-hover v-slot="{ hover }">
                        <v-card :class="{ 'on-hover': hover }" class="bookdesign rounded-lg "
                          :elevation="hover ? '24' : '2'">
                          <v-card-title>
                            <v-row dense>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-col cols="12" class="text-center justify-center d-flex align-center">
                                    <div style="height: 50px">
                                      <div class=" d-flex  justify-center titleofbook">
                                        <div v-on="on" class="d-flex titletext  caption justify-center pa-2">
                                          {{ item.titulo }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                </template>
                                <span>{{ item.titulo }}</span>
                              </v-tooltip>
                            </v-row>
                          </v-card-title>
                          <v-card-text class="pa-0">
                            <div class="d-flex justify-center align-center" style="height: 150px">
                              <v-img contain class="grey lighten-2 rounded-lg" max-width="150" max-height="100" :src="item.imagen != null
                                ? rutaServe + item.imagen
                                : 'https://cdn5.dibujos.net/dibujos/pintados/201809/pila-de-libros-colegio-11295770.jpg'
                                ">
                                <template v-slot:placeholder>
                                  <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </div>
                          </v-card-text>
                          <v-card-actions>
                            <v-row dense>
                              <v-col cols="12" class="d-flex justify-center">
                                <v-btn text class="white--text" @click="loadPlanLetor(item)">
                                  <v-icon left :class="hover
                                    ? 'animate__heartBeat animate__infinite	infinite'
                                    : ''
                                    " small>fas fa-book
                                  </v-icon>
                                  Leer
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-actions>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </template>


              </v-data-iterator>
            </v-col>

          </v-row>
        </v-col>


      </v-row>


    </template>
    <!--                        //////////////////////////////////////////////
                                                 /////      PLAN LECTOR ESTUDIANTES        ////
                                                ////////////////////////////////////////////// -->

    <template v-else-if="datoLogin.descripcion_perfil == 'Estudiante'">
      <v-tabs v-model="tab" dark class="rounded-lg" centered background-color="primary" active-class="tab-active"
        slider-color="#ffbc00">
        <v-tab class="font-weight-black"> Libros </v-tab>
        <v-tab class="font-weight-black">Calendario cívico</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col cols="12">
              <v-data-iterator :items-per-page.sync="itemsPerPage" :page.sync="page" :items="dataResponseEstudiante"
                :search="search">
                <template v-slot:header>
                  <v-row>
                    <v-col cols="12" class="d-flex justify-center pb-10">
                      <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify"
                        placeholder="Buscar libro" variant="solo" density="comfortable"
                        style="max-width:300px"></v-text-field>
                    </v-col>
                  </v-row>
                </template>

                <template v-slot:no-data>
                  <v-card outlined>
                    <v-card-text style="height: 240px" class="d-flex justify-center align-center">
                      Sin libros añadidos
                    </v-card-text>
                  </v-card>

                </template>
                <template v-slot:no-results>
                  <v-card outlined>
                    <v-card-text style="height: 240px" class="d-flex justify-center align-center">
                      Sin datos encontrados correspondientes a su busqueda
                    </v-card-text>
                  </v-card>

                </template>

                <template v-slot:default="props">
                  <v-row>
                    <v-col v-for="item in props.items" class="d-flex justify-center" :key="item.id" cols="12" sm="6"
                      md="4" lg="3">
                      <v-hover v-slot="{ hover }">
                        <v-card :class="{ 'on-hover': hover }" class="bookdesign rounded-lg "
                          :elevation="hover ? '24' : '2'">
                          <v-card-title>
                            <v-row dense>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-col cols="12" class="text-center justify-center d-flex align-center">
                                    <div style="height: 50px">
                                      <div class="d-flex justify-center titleofbook">
                                        <div v-on="on" class="d-flex titletext  caption justify-center pa-2">
                                          {{ item.titulo }}
                                        </div>
                                      </div>
                                    </div>
                                  </v-col>
                                </template>
                                <span>{{ item.titulo }}</span>
                              </v-tooltip>
                            </v-row>
                          </v-card-title>
                          <v-card-text class="pa-0">
                            <div class="d-flex justify-center align-center" style="height: 150px">
                              <v-img contain class="grey lighten-2 rounded-lg" max-width="150" max-height="100" :src="item.imagen != null
                                ? rutaServe + item.imagen
                                : 'https://cdn5.dibujos.net/dibujos/pintados/201809/pila-de-libros-colegio-11295770.jpg'
                                ">
                                <template v-slot:placeholder>
                                  <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </div>
                          </v-card-text>
                          <v-card-actions>
                            <v-row dense>
                              <v-col cols="12" class="d-flex justify-center">
                                <v-btn text class="white--text" @click="loadPlanLetor(item)">
                                  <v-icon left :class="hover
                                    ? 'animate__heartBeat animate__infinite	infinite'
                                    : ''
                                    " small>fas fa-book
                                  </v-icon>
                                  Leer
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-actions>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </template>


              </v-data-iterator>
            </v-col>
          </v-row>

        </v-tab-item>
        <v-tab-item>
          <v-data-iterator :items-per-page.sync="itemsPerPage" :page.sync="page" :items="responseCalendar"
            :search="search">
            <template v-slot:header>
              <v-row>
                <v-col class="d-flex justify-center pb-10" cols="12">
                  <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify"
                    placeholder="Buscar libro" variant="solo" density="comfortable"
                    style="max-width :300px"></v-text-field>
                </v-col>
              </v-row>

            </template>

            <template v-slot:no-data>
              <v-card outlined>
                <v-card-text class="d-flex justify-center align-center" style="height: 240px">
                  Sin libros añadidos
                </v-card-text>
              </v-card>

            </template>
            <template v-slot:no-results>
              <v-card outlined>
                <v-card-text class="d-flex justify-center  align-center" style="height: 240px">
                  Sin datos encontrados correspondientes a su busqueda
                </v-card-text>
              </v-card>
            </template>

            <template v-slot:default="props">
              <v-row>
                <v-col v-for="item in props.items" class="d-flex justify-center" :key="item.id" cols="12" sm="6" md="4"
                  lg="3">
                  <v-hover v-slot="{ hover }">
                    <v-card :class="{ 'on-hover': hover }" class="bookdesign rounded-lg" :elevation="hover ? '24' : '2'">
                      <v-card-title>
                        <v-row dense>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-col cols="12" class="text-center justify-center d-flex align-center">
                                <div style="height: 50px">
                                  <div class=" d-flex justify-center titleofbook">
                                    <div v-on="on" class="d-flex titletext #ffbc00--text caption justify-center pa-2">
                                      {{ item.titulo }}
                                    </div>
                                  </div>
                                </div>
                              </v-col>
                            </template>
                            <span>
                              {{ item.titulo }}
                            </span>
                          </v-tooltip>

                        </v-row>
                      </v-card-title>
                      <v-card-text class="pa-0">
                        <div class="d-flex justify-center align-center" style="height: 150px">
                          <v-img contain class="grey lighten-2 rounded-lg" max-width="150" max-height="100" :src="item.imagen != null
                            ? rutaServe + item.imagen
                            : 'https://cdn5.dibujos.net/dibujos/pintados/201809/pila-de-libros-colegio-11295770.jpg'
                            ">
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>
                      </v-card-text>
                      <v-card-actions>
                        <v-row dense>
                          <v-col cols="12" class="d-flex justify-center">
                            <v-btn text class="white--text" @click="loadPlanLetor(item)">
                              <v-icon left :class="hover
                                ? 'animate__heartBeat animate__infinite	infinite'
                                : ''
                                " small>fas fa-book
                              </v-icon>
                              Leer
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </template>


          </v-data-iterator>
        </v-tab-item>

      </v-tabs-items>
    </template>
    <template v-else>
      <v-alert class="mt-14 mb-14" color="warning" dark border="left">
        No tienes permisos necesarios para ver este contenido.
      </v-alert>
    </template>


    <!-- fin consulta -->

    <!-- END de modal para visualizar Imagen-->

    <component :is="compName" :estadoModal="estadoModalConfig" :parametros="parametroConfig" @close="closeModal">
    </component>
  </div>
</template>
                
<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";

import PlanLectorComp from "./components/PlanLectorFormComp";
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import TableButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../../components/ComponentsEst/AutocompleteComp.vue';
export default {

  name: "PlanLector",
  components: {
    PlanLectorComp,
    ComunDialogComp,
    TableButtonComp,
    AutocompleteComp

  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    rutaServe: API_URL,
    gradochipfilter: false,
    tab: 0,
    paramComponente: { id_modulo: 9, id_submodulo: 28 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    search: '',
    loadingData: false,
    itemsPerPage: 10,
    itemsPerPageArray: [10, 20, 30],
    page: 1,

    //// CONSULTA PRINCIPAL
    // evento: 'agregar',
    datos: [],
    datosFilter: [],

    listNivel: [],
    nivel: {},

    listGrado: [],
    gradoFilter: [],
    grado: {},

    responseEstudiante: [],
    dataResponseEstudiante: [],
    responseCalendar: [],

    formTitle: "Visualizar Galeria del Gestor de Contenido",
    // componente Fomulario Colegio
    compName: null,
    estadoModalConfig: true,
    parametroConfig: [],
  }),

  //computadas
  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    numberOfPages() {
      return Math.ceil(this.dataResponseEstudiante.length / this.itemsPerPage)
    },
  },

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
    // -- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-- cargar Parametros de inicio del componente --
    async loadMain() {
      if (this.datoLogin.descripcion_perfil === "Estudiante") {
        this.planLectorEstudiante();
      }
      this.limpiarForm();
      /*      
                this.eventNivel({id_nivel: 2, desc_nivel:'Primaria'})
                
                this.eventGrado( {
                                        id_grado:1,
                                        id_nivel: 2,
                                        desc_nivel:'Primaria',
                                        desc_grado:'1 Grado',
                                        activo: false
                                    })
            
            */
    },

    async planLectorEstudiante() {
      try {
        let paramsEstudiante = {
          colegio: this.datoLogin.id_colegio,
          persona: this.datoLogin.id_persona,
        };

        let estudianteResponse = await axios.post(
          `/recursosDigitales/planLector/planlectorestudiante`,
          { filter: paramsEstudiante }
        );

        if (!estudianteResponse.data || estudianteResponse.data.length === 0) {
          throw new Error("No se encontró información del estudiante");
        }

        const estudianteData = estudianteResponse.data[0];

        const nivelMap = {
          Inicial: 1,
          Primaria: 2,
          Secundaria: 3,
          "Calendario Cívico": 4,
        };

        const gradoMap = {
          Inicial: {
            "3 años": 3,
            "4 años": 4,
            "5 años": 5,
          },
          Primaria: {
            "1er grado": 1,
            "2do grado": 2,
            "3er grado": 3,
            "4to grado": 4,
            "5to grado": 5,
            "6to grado": 6,
          },
          Secundaria: {
            "1er Año": 1,
            "2do Año": 2,
            "3er Año": 3,
            "4to Año": 4,
            "5to Año": 5,
          },
          "Calendario Cívico": {
            "Calendario Cívico": 4,
          },
        };

        const nivelValue = nivelMap[estudianteData.desc_nivel];
        const gradoValue =
          gradoMap[estudianteData.desc_nivel][estudianteData.desc_grado];

        if (!nivelValue || !gradoValue) {
          throw new Error("Nivel o grado no reconocido");
        }

        const params = {
          id_nivel: nivelValue,
          id_grado: gradoValue,
        };
        const paramsCalendario = {
          id_nivel: 4,
          id_grado: 1,
        };

        let gradoResponse = await axios.post(
          `/recursosDigitales/planLector/grado`,
          { filter: params }
        );
        this.responseEstudiante = gradoResponse.data;

        let calendarioCivico = await axios.post(
          `/recursosDigitales/planLector/`,
          { filter: paramsCalendario }
        );
        this.responseCalendar = calendarioCivico.data;

        let librosResponse = await axios.post(
          `/recursosDigitales/planLector/`,
          { filter: params }
        );
        this.dataResponseEstudiante = librosResponse.data;

        if (this.dataResponseEstudiante.length === 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `El Registro no posee Información: `,
            tiempo: null,
          }); //${nivel.desc_nivel}
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1
    },
    prevPage() {
      if (this.page - 1 >= 1) this.page -= 1
    },



    async eventNivel(nivel) {
      this.nivel = nivel;
      this.grado = {
        id_grado: null,
        id_nivel: null,
        desc_nivel: null,
        desc_grado: null,
        activo: false,
      };
      let params = { id_nivel: nivel.id_nivel };
      try {
        let response = await axios.post(`/recursosDigitales/planLector/grado`, {
          filter: params,
        });
        this.gradoFilter = response.data;

        let response02 = await axios.post(`/recursosDigitales/planLector/`, {
          filter: params,
        });
        this.datosFilter = response02.data;

        if (this.datosFilter.length === 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `El Registro no posee Información: ${nivel.desc_nivel}`,
            tiempo: null,
          });
        }
        this.gradochipfilter = false
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }

      // this.setEnviarMens({tipo:"S", mensaje: `Nivel Seleccionado: ${nivel.desc_nivel}`, tiempo:null})
      // this.gradoFilter = this.listGrado.filter(el=>el.id_nivel == nivel.id_nivel)
      return true;
    },

    async eventGrado(grado) {
      grado.activo = true;
      this.gradochipfilter = true
      this.grado = grado;

      let params = { id_nivel: grado.id_nivel, id_grado: grado.id_grado };
      try {
        let response = await axios.post(`/recursosDigitales/planLector/`, {
          filter: params,
        });
        this.datosFilter = response.data;

        if (this.datosFilter.length === 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `El grado seleccionado no posee informacion: ${grado.desc_grado}`,
            tiempo: 3000,
          });
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
      return true;
    },

    loadPlanLetor(item) {
      // this.setEnviarMens({tipo:"S", mensaje: `Load Plan Lector: ${item}`, tiempo:null})
      this.parametroConfig = { evento: "view", item };
      this.compName = "PlanLectorComp";
      this.estadoModalConfig = true;
      this.openFullScreen();
    },


    openFullScreen() {
      var docElm = document.documentElement;
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.msRequestFullscreen) {
        docElm = document.body; //overwrite the element (for IE)
        docElm.msRequestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    },

    closeFullScreen() {
      if (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      ) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },

    limpiarForm() {
      this.nivel = {
        id_nivel: null,
        desc_nivel: "Seleccione un nivel",
        activo: false,
      };

      this.grado = {
        id_grado: null,
        id_nivel: null,
        desc_nivel: null,
        desc_grado: null,
        activo: false,
      };

      this.listNivel = [
        {
          id_nivel: 1,
          desc_nivel: "Inicial",
          activo: false,
        },
        {
          id_nivel: 2,
          desc_nivel: "Primaria",
          activo: false,
        },
        {
          id_nivel: 3,
          desc_nivel: "Secundaria",
          activo: false,
          audio: null,
        },

        {
          id_nivel: 4,
          desc_nivel: "Calendario Cívico",
          activo: false,
        },
      ];
    },

    /*******cerrar modal y blanquear arreglos */
    closeModal() {
      this.estadoModalConfig = false;
      this.loadMain();
      this.closeFullScreen();
    },

    //-------mostrar registros------------
    /*
            async getNivel(id_ano_lectivo){
                let params = {id_ano_lectivo, id_colegio:sessionStorage.id_colegio}
                try{
                    
                    let response =await axios.post(`/sistema/integral/getNivelAdm/`, {filter: params})
                    this.listNivel = response.data
                    
                }catch(error){
 
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }                        
 
            },
            */
  },
};
</script>
                
<style scoped lang="scss">
.bookdesign {
  width: 200px;
  height: 300px;

  background: rgb(24 49 83);
  border-left: 20px solid #001c40 !important;
}

.titleofbook {
  background: rgb(50, 92, 150);
}

.titletext {
  width: 135px;
  max-height: 50px;
  word-break: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #ffbc00;
}

.v-card {
  transition: transform 0.4s ease-in-out
}

.v-card.on-hover:hover {
  transform: scale(1.1)
}
</style>
                  
                
                